module.exports = __webpack_public_path__ + "e453d0a3.png";